export const INSTRCTOR_SCHEMA = [
  {
    column_name: "name",
    label: "Name",
    type: "text",
    required: true,
  },
  {
    column_name: "email",
    label: "Email",
    type: "text",
    required: true,
    required_or: [3],
  },
  {
    column_name: "partner_id",
    label: "Select Partner (Optional)",
    type: "selector",
  },
  {
    column_name: "mobile_number",
    label: "Mobile Number",
    type: "text",
    required_or: [1],
  },
  {
    column_name: "activation_start_date",
    label: "Activation start date",
    type: "date",
  },
  {
    column_name: "activation_end_date",
    label: "Activation end date",
    type: "date",
  },
  ,
  {
    column_name: "password",
    label: "Enter password",
    type: "password",
    required: true,
  },
  {
    column_name: "confirm_password",
    label: "Confirm password",
    type: "password",
    required: true,
  },
  {
    column_name: "active",
    label: "Active",
    type: "checkbox",
  },
];
export const INSTRUCTOR_DISPLAY_SCHEMA = [
  {
    column_name: "name",
    label: "Name",
  },
  {
    column_name: "email",
    label: "Email",
  },
  {
    column_name: "partner_id",
    label: "Partner",
  },
  {
    column_name: "mobile_number",
    label: "Mobile Number",
  },
  {
    column_name: "activation_start_date",
    label: "Activation start date",
  },
  {
    column_name: "activation_end_date",
    label: "Activation end date",
  },
  {
    column_name: "active",
    label: "Active",
  },
];
